/**
 * Client configuration.
 *
 * `FALLBACK_BASE_CURRENCY` mirrors the server's `BASE_CURRENCY` env var. It is duplicated
 * rather than fetched because *something* has to denominate an amount before the first
 * authenticated request answers — the login screen and an empty money input both want it.
 *
 * It is a **fallback and nothing more.** The authority is `GET /currencies`, which the
 * shell loads once per session and which knows every currency the group configured, its
 * decimals and its rate (`features/currencies/CurrencyProvider.jsx`). Use `useCurrencies()`
 * or `useBaseCurrency()` in components; reach for this constant only where no React
 * context exists.
 */
export const FALLBACK_BASE_CURRENCY = import.meta.env?.VITE_BASE_CURRENCY || 'USD';

/**
 * @deprecated Read the live list with `useBaseCurrency()` instead. Kept as the cold-start
 * value so a module imported before the provider mounts still has a currency to name.
 */
export const BASE_CURRENCY = FALLBACK_BASE_CURRENCY;

export const APP_VERSION = import.meta.env?.VITE_APP_VERSION || '0.1.0';

export default { BASE_CURRENCY, FALLBACK_BASE_CURRENCY, APP_VERSION };
